import React from 'react'
import { Icon } from '@alto-avios/alto-ui'
import styles from './SearchFieldSwapButton.module.scss'

type ButtonProps = {
  label?: string
  onClick?(): void
  disabled?: boolean
}

const SearchFieldSwapButton = ({ label, onClick, disabled }: Readonly<ButtonProps>) => {
  return (
    <button
      aria-label={label ?? 'swap button'}
      onClick={onClick}
      disabled={disabled}
      className={styles.swapButton}
      type="button"
      data-testid="swap-button"
    >
      <Icon iconName="right-left" iconPrefix="fas" iconSize="1x" />
    </button>
  )
}

export default SearchFieldSwapButton
